import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_checkmark-alt",
  "use": "svg_checkmark-alt-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"svg_checkmark-alt\"><g fill=\"#000\" fill-rule=\"nonzero\"><path d=\"M9 0C4 0 0 4 0 9s4 9 9 9 9-4 9-9-4-9-9-9Zm0 16.9c-4.3 0-7.9-3.5-7.9-7.9S4.6 1.1 9 1.1s7.9 3.6 7.9 7.9c0 4.3-3.5 7.9-7.9 7.9Z\" /><path d=\"M7.5 11.1 4.9 8.5l-.8.8 3.4 3.4 6.4-6.4-.8-.8z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol